module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-46-eee083f41c822ba99f0166d5c120ca77.svg";